import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import QuestionsTable, {
  QUESTION_COLUMNS, QUESTION_CARDS, QUESTION_MIN_TABLE_WIDTH
} from 'components/Tables/Questions';
import * as DataList from 'components/DataList';
import Card from 'components/Card';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import BookingsSidebar from '../bookings/bookings-sidebar';

const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F6F6FA;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'viewStore', 'questionStore') @observer
class QuestionIndexPage extends Component {
  @observable visible = true;

  render() {
    let content;
    let {
      questionStore,
      questionStore: {
        questions: {
          isLoading,
          isError
        }
      }, viewStore
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={QUESTION_COLUMNS}
          cards={QUESTION_CARDS}
          minTableWidth={QUESTION_MIN_TABLE_WIDTH}
          noun="questions"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="questions" onRetry={() => questionStore.loadQuestions()} />;
    }
    if (!isError && !isLoading) {
      content = <QuestionsTable />
    }
    return (
      <div>
        <Helmet>
          <title>Questions | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
              <BookingsSidebar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Sticky enabled={true} top={0} innerZ={9}>
                <SearchBars.QuestionSearch key={viewStore.listFiltersVersion} />
              </Sticky>
              <Card>
                {content}
              </Card>
            </PageWrapGray>
          </div>
        </div>
      </div>
    )
  }
};

export default QuestionIndexPage;